import React from 'react';
import ProcessStep from '@/components/ProcessStep';

const ProcessSection = () => {
  return (
    <section id="process" className="section-padding bg-background relative">
      <div className="container-wide mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-primary font-medium tracking-[0.3em] uppercase mb-4 text-sm">
            How We Work
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Our <span className="gradient-text">Process</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            A proven four-step process that ensures exceptional results every time, restoring
            your items to pristine condition.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <ProcessStep number="01" title="Inspection" description="We thoroughly examine your items to determine the best approach for restoration." delay="0.2s" />
          <ProcessStep number="02" title="Preparation" description="Items are carefully prepared and protected before the vapour blasting process." delay="0.3s" />
          <ProcessStep number="03" title="Blasting" description="Our advanced vapour blasting equipment gently removes contaminants from the surface." delay="0.4s" />
          <ProcessStep number="04" title="Finishing" description="Final inspection and finishing touches ensure perfect results before delivery." delay="0.5s" />
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
